/**
 * Fullscreen Mode Strategy
 *
 * Display mode strategy for fullscreen popups.
 * Fullscreen popups cover the entire viewport.
 * Sizing is handled via CSS (100vw x 100vh).
 * Inner width is handled inside the iframe (passed via PHP in the iframe URL)
 * so custom CSS in the iframe can add full-width backgrounds.
 */

import { BaseDisplayModeStrategy } from './base-strategy';

/**
 * Strategy for fullscreen display mode.
 */
export class FullscreenModeStrategy extends BaseDisplayModeStrategy {
	/**
	 * Returns CSS classes for fullscreen mode.
	 */
	public getDisplayModeClasses = (): string[] => {
		return ['gp-popup--fullscreen'];
	};

	/**
	 * Fullscreen popups have no visible backdrop to click.
	 */
	public shouldCloseOnBackdropClick = (): boolean => {
		return false;
	};
}
